import React from 'react';
import type { TextV2Props } from '@withjoy/joykit';
import { TextV2 } from '@withjoy/joykit';
import type { CountdownFormat } from '@localization/hooks/useCountdown';
import { useCountdown } from '@localization/hooks/useCountdown';
import { GuestSiteTypographyOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride';
import { body1ToCaptionOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride.constants';

interface InternalEventCountdownProps {
  timezone?: string;
  milliseconds: number;
  countdownFormat?: CountdownFormat;
}

interface EventCountdownProps extends Readonly<InternalEventCountdownProps>, TextV2Props {}

const EventCountdown: React.FC<EventCountdownProps> = ({ milliseconds, countdownFormat, ...restProps }) => {
  const { formattedDuration } = useCountdown(milliseconds, countdownFormat);

  return (
    <GuestSiteTypographyOverride override={body1ToCaptionOverride}>
      <TextV2
        typographyVariant="body1"
        {...restProps}
      >
        {formattedDuration}
      </TextV2>
    </GuestSiteTypographyOverride>
  );
};

EventCountdown.displayName = 'EventCountdown';

export { EventCountdown };
